import { Drawer, type DrawerProps, styled } from '@mui/material';

import { removeTheseProps } from '@/utils';

import { drawerSizeLookup, type PresetDrawerSize } from '../data';

export type StyledDrawerSize = PresetDrawerSize | `${number}px` | `${number}%`;

export type StyledDrawerProps = Omit<
  DrawerProps,
  'children' | 'content' | 'title'
> & {
  size?: StyledDrawerSize;
} & Required<Pick<DrawerProps, 'open' | 'onClose'>>;

export const StyledDrawer = styled(
  ({ className, ...props }: StyledDrawerProps) => (
    <Drawer
      size="small"
      anchor="right"
      {...props}
      classes={{ paper: className }}
    />
  ),
  {
    shouldForwardProp: removeTheseProps<StyledDrawerProps>('size'),
  },
)<StyledDrawerProps>(({ size = 'small' }) => {
  const isCustomSize = size.endsWith('px') || size.endsWith('%');

  const width = isCustomSize
    ? size
    : drawerSizeLookup[size as PresetDrawerSize];

  return {
    width: 520,
    '&.MuiDrawer-paper': {
      display: 'flex',
      flexDirection: 'column',
      boxShadow: 'none',
      width,
      borderTopLeftRadius: 16,
      borderBottomLeftRadius: 16,
      border: '1px solid #D8DBDF',
    },
    '&.MuiModal-backdrop': {
      backgroundColor: 'rgba(0,0,0,0.3)',
    },
  };
});
